import { KnownType } from '../../../types';
import { addCommodityFields } from './addCommodityFields';
import { removeFieldsFromCommodity } from './removeCommodityFields';
import { TemplateWithCommodity } from './types';

const defaultGrossWeightSection = {
  grossWeight: {
    _type: 'WEIGHT' as KnownType,
    _value: {
      weight: {
        _display: { name: 'Gross Weight' },
        _ai: {
          placeholder: '<NUMBER WITHOUT UNITS>',
          comment: 'Weight including packaging, only when stated separately',
        },
      },
      units: {
        _display: { name: 'Units' },
        _ai: { placeholder: '<KG or LBS>' },
        _type: 'WEIGHT_UNITS' as KnownType,
      },
    },
  },
};

export function addGrossWeight<T extends TemplateWithCommodity>(template: T) {
  return addCommodityFields(template, defaultGrossWeightSection);
}

export function removeGrossWeight(template: TemplateWithCommodity) {
  return removeFieldsFromCommodity(template, ['grossWeight']);
}
